import { Chart as ChartJS, registerables, ChartOptions } from "chart.js";
import { Chart } from "react-chartjs-2";
import theme from "../../../../../../../theme";

ChartJS.register(...registerables);

type EntryChartBarProps = {
  monthlyCounts: number[];
};

const options: ChartOptions<"bar"> = {
  responsive: true,
  maintainAspectRatio: false,
  scales: {
    x: {
      grid: {
        drawOnChartArea: false,
        drawTicks: false,
      },
      border: {
        display: false,
      },
      ticks: {
        color: theme.colours["font-dark"],
        font: {
          size: 11,
          lineHeight: "22px",
        },
        padding: 6,
        maxRotation: 0,
        minRotation: 0,
        autoSkip: false,
      },
    },
    y: {
      min: 0,
      max: 30,
      position: "right",
      grid: {
        drawOnChartArea: true,
        color: theme.colours["border-grey"],
      },
      border: {
        display: false,
      },
      ticks: {
        stepSize: 15,
        color: theme.colours["font-dark"],
        font: {
          size: 11,
        },
      },
    },
  },
  plugins: {
    legend: {
      display: false,
    },
  },
};

export function EntryChartBar({ monthlyCounts }: EntryChartBarProps) {
  const chartData = {
    labels: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
    datasets: [
      {
        data: monthlyCounts,
        backgroundColor: theme.colours.brand,
        borderRadius: 50,
        borderSkipped: false,
        maxBarThickness: 4,
      },
    ],
  };

  return <Chart type="bar" data={chartData} options={options} />;
}
